module.exports = __webpack_public_path__ + "static/media/kaptein.b5c5a328.m4a";